import React, { ElementType } from 'react';
import { StyledButton, StyledButtonWrapper, StyledRightArrowIcon } from './dreamlines-button.style';

export type ButtonType = {
    [key in
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'text'
        | 'sticky'
        | 'expand'
        | 'cabin']?: boolean;
};

interface IDreamlinesButtonType extends ButtonType {
    children: React.ReactNode;
    disabled?: boolean;
    style?: React.CSSProperties;
    wrapperStyle?: React.CSSProperties;
    excludeArrow?: boolean;
    outlined?: boolean;
    arrowSize?: 'S';
    domType?: ElementType;
    className?: string;
}

interface IButtonWithOnClick extends IDreamlinesButtonType {
    onClick: () => void;
}

interface IButtonWithHref extends IDreamlinesButtonType {
    redirectUrl: string;
}

export type IDreamlinesButton = IButtonWithHref | IButtonWithOnClick;

export const DreamlinesButton = (props: IDreamlinesButton) => {
    const btnType = props.tertiary ? 'tertiary' : props.secondary ? 'secondary' : 'primary';

    return (
        <StyledButtonWrapper data-testid="dreamlines-button" style={props.wrapperStyle}>
            <StyledButton
                onClick={(props as IButtonWithOnClick).onClick}
                data-testid={btnType + '-button'}
                href={(props as IButtonWithHref).redirectUrl}
                style={props.style}
                btntype={btnType}
                as={props.domType}
                domType={Boolean(props.domType)}
                className={props.className || ''}
            >
                {props.children}
                {!props.excludeArrow && <StyledRightArrowIcon size={props.arrowSize} />}
            </StyledButton>
        </StyledButtonWrapper>
    );
};

DreamlinesButton.defaultProps = {
    disabled: false,
};
